module.exports = __webpack_public_path__ + "img/hm_block03_03_tc.266c236b.png";